export const IMPORT_SALARIES_VALIDATION_RULES = {
  effectiveDate: {
    isRequiredTrim: {
      value: true,
    },
  },
  file: {
    isRequiredFile: {
      value: true,
    },
    fileOfExtension: {
      value: [".xls", ".xlsx"],
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/bulkSalaries/bulkSalariesValidationRules.js